import { createDecorator } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
import { DEFAULT_EDITOR_ASSOCIATION } from '../../../common/editor.js';
var SettingMatchType;
( (function(SettingMatchType) {
    SettingMatchType[SettingMatchType["None"] = 0] = "None";
    SettingMatchType[SettingMatchType["WholeWordMatch"] = 1] = "WholeWordMatch";
    SettingMatchType[SettingMatchType["KeyMatch"] = 2] = "KeyMatch";
})(SettingMatchType || (SettingMatchType = {})));
function validateSettingsEditorOptions(options) {
    return {
        ...options,
        override: DEFAULT_EDITOR_ASSOCIATION.id,
        pinned: true
    };
}
const IPreferencesService = ( createDecorator('preferencesService'));
const FOLDER_SETTINGS_PATH = '.vscode/settings.json';
const DEFAULT_SETTINGS_EDITOR_SETTING = 'workbench.settings.openDefaultSettings';
const USE_SPLIT_JSON_SETTING = 'workbench.settings.useSplitJSON';
export { DEFAULT_SETTINGS_EDITOR_SETTING, FOLDER_SETTINGS_PATH, IPreferencesService, SettingMatchType, USE_SPLIT_JSON_SETTING, validateSettingsEditorOptions };
